module.exports = __webpack_public_path__ + "img/right_angle_corner_line_icon.0963deee.svg";